import { createStore } from "vuex";
import { config } from "vuex-module-decorators";

import {
  AuthModule,
  CursosModule,
  EmailTemplatesModule,
  FamiliasFormulariosModule,
  FamiliasListadoModule,
  HomeModule,
  MenorModule,
  ProfesionalesFormulariosModule,
  ProfesionalesListadoModule,
  ServicioListadoModule,
  ServiciosProgramadosModule,
  UsuariosListadoModule,
} from "@/store/modules";
import BodyModule from "@/store/modules/BodyModule";
import BreadcrumbsModule from "@/store/modules/BreadcrumbsModule";
import ConfigModule from "@/store/modules/ConfigModule";

config.rawError = true;

const store = createStore({
  modules: {
    AuthModule,
    BodyModule,
    BreadcrumbsModule,
    ConfigModule,
    CursosModule,
    EmailTemplatesModule,
    FamiliasFormulariosModule,
    FamiliasListadoModule,
    HomeModule,
    MenorModule,
    ProfesionalesFormulariosModule,
    ProfesionalesListadoModule,
    ServicioListadoModule,
    ServiciosProgramadosModule,
    UsuariosListadoModule,
  },
});

export default store;
